import React from 'react';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube, ArrowRight } from 'lucide-react';
import { contactInfo } from '../mockData';
import logo from './assets/logo.jpeg'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#services' },
    { name: 'Laptop Sales', href: '#sales' },
    { name: 'Spares', href: '#spares' },
    { name: 'About Us', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Screen Replacement',
    'Battery Replacement',
    'Keyboard Repair',
    'Data Recovery',
    'Hardware Upgrade',
    'Virus Removal'
  ];

  const brands = [
    'HP Laptops',
    'Dell Laptops',
    'Lenovo Laptops',
    'Apple MacBook',
    'Asus Laptops',
    'Acer Laptops'
  ];

  return (
    <footer className="bg-gradient-to-br from-[#2E3C5B] via-[#1f2a3f] to-[#2E3C5B] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 - About */}
          <div className="space-y-6">
            <img 
              src={logo}
              alt="EBR Systems & Services" 
              className="h-16 w-auto object-contain bg-white p-2 rounded-lg"
            />
            <p className="text-gray-300 leading-relaxed">
              India's most trusted laptop service and sales provider since 2007. We specialize in genuine repairs and original parts.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E94B3C] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E94B3C] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Twitter size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E94B3C] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E94B3C] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#E94B3C] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-300 hover:text-[#E94B3C] transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a 
                    href="#services"
                    className="text-gray-300 hover:text-[#E94B3C] transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone size={18} className="text-[#E94B3C] mt-1 flex-shrink-0" />
                <div>
                  <a href={`tel:${contactInfo.phone}`} className="text-gray-300 hover:text-[#E94B3C] transition-colors block">
                    {contactInfo.phone}
                  </a>
                  <a href={`tel:${contactInfo.alternatePhone}`} className="text-gray-300 hover:text-[#E94B3C] transition-colors block">
                    {contactInfo.alternatePhone}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail size={18} className="text-[#E94B3C] mt-1 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-gray-300 hover:text-[#E94B3C] transition-colors">
                  {contactInfo.email}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[#E94B3C] mt-1 flex-shrink-0" />
                <p className="text-gray-300">
                  {contactInfo.address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              © {currentYear} EBR Systems & Services. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-[#E94B3C] transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-[#E94B3C] transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-[#E94B3C] transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
